import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isTokenExpired, getRole } from "Service/Service";
import { ROUTES } from "definitions/constant/routes";
import {
  superAdminUserNavConfig,
  adminUserNavConfig,
  userNavConfig,
} from "layouts/NavConfig";

interface PrivateRouteProps {
  children: React.ReactNode;
}

const menuMapping: any = {
  superadmin: superAdminUserNavConfig,
  admin: adminUserNavConfig,
  user: userNavConfig,
  employee: adminUserNavConfig,
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const location = useLocation();
  const role = getRole();

  if (isTokenExpired()) {
    return <Navigate to={ROUTES.login} replace />;
  }

  if (!role) {
    // Should not happen if token is not expired, but as a safeguard.
    return <Navigate to={ROUTES.login} replace />;
  }

  const allowedRoutes = menuMapping[role]?.map((route: any) => route.path);

  // Account/profile page is accessible by all authenticated roles
  if (location.pathname === ROUTES.account) {
    return <>{children}</>;
  }

  // Allow access to root for non-user roles, even if not explicitly in their navConfig
  if (role !== "user" && location.pathname === ROUTES.root) {
    return <>{children}</>;
  }
  
  // Special case for user role, default page is /agent-dashboard
  if (role === "user" && location.pathname === ROUTES.root) {
    return <Navigate to={ROUTES.agentDashboard} replace />;
  }

  if (allowedRoutes && !allowedRoutes.includes(location.pathname)) {
    // If the current path is not in the allowed routes, redirect.
    if (role === "user") {
      return <Navigate to={ROUTES.agentDashboard} replace />;
    }
    return <Navigate to={ROUTES.root} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;